
import Vue from "vue";

export default Vue.component("SHSettledCardSkeleton", {
  components: {
    QSkeleton: () => import("../elements/QSkeleton.vue"),
  },
});
